


import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center mb-4">
              <div className="w-10 h-10 bg-red-700 rounded-lg flex items-center justify-center mr-3">
                <i className="ri-hammer-line text-white"></i>
              </div>
              <h3 className="text-xl font-bold" style={{ fontFamily: '"Pacifico", serif' }}>
                Chavez Castro
              </h3>
            </div>
            <p className="text-gray-300 mb-4">
              Professional construction and landscaping services. Building dreams, creating beautiful outdoor spaces.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-300 hover:text-white">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-300 hover:text-white">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="text-gray-300 hover:text-white">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Services</h4>
            <ul className="space-y-2">
              <li><Link to="/construction" className="text-gray-300 hover:text-white">Construction</Link></li>
              <li><Link to="/landscape" className="text-gray-300 hover:text-white">Landscaping</Link></li>
              <li><Link to="/portfolio" className="text-gray-300 hover:text-white">Portfolio</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <div className="space-y-2 text-gray-300">
              <p><i className="ri-phone-line mr-2"></i>(901) 721-3628</p>
              <p><i className="ri-mail-line mr-2"></i>info@ChavezCastro.com</p>
              <p><i className="ri-map-pin-line mr-2"></i>1050 Lorraine Street, Memphis, TN 38122</p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-300">
          <p>&copy; 2025 <a href="https://adhive.media" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300 transition-colors">adHive.media</a> llc. All rights reserved.</p>
          <p>Website designed and managed by <a href="mailto:sales@adHive.media" className="text-blue-400 hover:text-blue-300 transition-colors">sales@adHive.media</a></p>
        </div>
      </div>
    </footer>
  );
}

